/**
 * 現像液 DB
 *
 * 主要モノクロ現像液と希釈バリエーション。
 * id は dev-times.js のキーと対応する。
 */

export const DEVELOPERS = [
  // Kodak
  { id: 'd76-stock',     brand: 'Kodak',   name: 'D-76',          dilution: 'stock' },
  { id: 'd76-1+1',       brand: 'Kodak',   name: 'D-76',          dilution: '1+1' },
  { id: 'hc110-b',       brand: 'Kodak',   name: 'HC-110',        dilution: 'B (1:31)' },
  { id: 'hc110-h',       brand: 'Kodak',   name: 'HC-110',        dilution: 'H (1:63)' },
  { id: 'xtol-stock',    brand: 'Kodak',   name: 'XTOL',          dilution: 'stock' },
  { id: 'xtol-1+1',      brand: 'Kodak',   name: 'XTOL',          dilution: '1+1' },
  { id: 'tmax-dev',      brand: 'Kodak',   name: 'T-Max Developer', dilution: '1+4' },

  // Ilford
  { id: 'id11-stock',    brand: 'Ilford',  name: 'ID-11',         dilution: 'stock' },
  { id: 'id11-1+1',      brand: 'Ilford',  name: 'ID-11',         dilution: '1+1' },
  { id: 'ddx-1+4',       brand: 'Ilford',  name: 'DD-X',          dilution: '1+4' },
  { id: 'ilfotec-hc-1+31', brand: 'Ilford', name: 'Ilfotec HC',   dilution: '1+31' },
  { id: 'perceptol-stock', brand: 'Ilford', name: 'Perceptol',    dilution: 'stock' },
  { id: 'perceptol-1+1', brand: 'Ilford',  name: 'Perceptol',     dilution: '1+1' },
  { id: 'microphen',     brand: 'Ilford',  name: 'Microphen',     dilution: 'stock' },

  // Adox / Pyro系
  { id: 'rodinal-1+25',  brand: 'Adox',    name: 'Rodinal',       dilution: '1+25' },
  { id: 'rodinal-1+50',  brand: 'Adox',    name: 'Rodinal',       dilution: '1+50' },
  { id: 'rodinal-1+100', brand: 'Adox',    name: 'Rodinal',       dilution: '1+100 (stand)' },
  { id: 'pyrocat-hd',    brand: 'Photographers Formulary', name: 'Pyrocat-HD', dilution: '1:1:100' },
  { id: 'pmk-pyro',      brand: 'Photographers Formulary', name: 'PMK Pyro',   dilution: '1:2:100' },

  // Foma
  { id: 'fomadon-r09-1+50', brand: 'Foma', name: 'Fomadon R09',   dilution: '1+50' },
  { id: 'fomadon-lqn',   brand: 'Foma',    name: 'Fomadon LQN',   dilution: '1+10' },

  // Eco-friendly
  { id: 'caffenol-cm',   brand: 'DIY',     name: 'Caffenol-C-M',  dilution: 'standard' },
];

export function getDeveloperById(id) {
  return DEVELOPERS.find((d) => d.id === id);
}

export function formatDeveloperLabel(dev) {
  if (!dev) return '—';
  return `${dev.name} ${dev.dilution}`;
}
